import React from "react";
import { Link } from "react-router-dom";
import "../subscriptionform/Subscription.css";
import "../newPayment/NewPayment.css"

const NewPayment = () => {
  return (
    <div className="subscription-section w-100 position-relative add-new-payment-option-sec">
      <Link rel="stylesheet" to="/signup" className="back-btn">
        Back
      </Link>
      <div className="subscription-box d-flex flex-wrap align-content-center justify-content-center ">
        <div className="inner-subscription d-flex flex-wrap align-content-center justify-content-center">
          <div class="modal-payment-all-option">
            <div class=" modal-payment-field">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h1 class="modal-title" id="exampleModalToggleLabel2">
                      Add New Payment Method
                    </h1>
                  </div>
                  <div class="modal-body-new">
                    <div className="modal-payment-field-body">
                      <div className="top-payment-option d-flex align-items-center gap-2">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="32" height="32" rx="10" fill="#FD59D9" />
                          <g clip-path="url(#clip0_147_4059)">
                            <path
                              d="M22.666 9.33331H9.33268C8.40768 9.33331 7.67435 10.075 7.67435 11L7.66602 21C7.66602 21.925 8.40768 22.6666 9.33268 22.6666H22.666C23.591 22.6666 24.3327 21.925 24.3327 21V11C24.3327 10.075 23.591 9.33331 22.666 9.33331ZM22.666 21H9.33268V16H22.666V21ZM22.666 12.6666H9.33268V11H22.666V12.6666Z"
                              fill="white"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_147_4059">
                              <rect
                                width="20"
                                height="20"
                                fill="white"
                                transform="translate(6 6)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        <p>Debit/Credit Card</p>
                      </div>
                      <div className="form-body-modal">
                        <h6>Card Details</h6>
                        <form action="">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-floating mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="floatingInput"
                                  placeholder="Name on Card"
                                />
                                <label for="floatingInput">Name on Card</label>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-floating mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="floatingInput"
                                  placeholder="Card Number"
                                />
                                <label for="floatingInput">Card Number</label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-floating mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="floatingInput"
                                  placeholder="Card Number"
                                />
                                <label for="floatingInput">Card Expiry</label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-floating mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="floatingInput"
                                  placeholder="Card Number"
                                />
                                <label for="floatingInput">Card Expiry</label>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer d-flex align-items-center gap-2 justify-content-between ">
                    <div className="left-box">
                      <Link href="" className="btn btn-primary btn-disabled">
                        Cancel
                      </Link>
                    </div>
                    <div className="right-box">
                      <Link href="" className="btn btn-primary btn-disabled">
                        Back
                      </Link>
                      <Link
                        className="btn btn-primary next-btn"
                        to="/setup-your-profile"
                      >
                        Next
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewPayment;
